var convert = require('./convert'),
    func = convert('uniqBy', require('../uniqBy'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/fp/uniqBy.js
// module id = 2058
// module chunks = 0